@if (this.loadingService.isLoading()) {
<div class="overlay">
  <div class="spinner">
    <mat-progress-bar mode="indeterminate" diameter="48"></mat-progress-bar>
    <div class="text">Cargando...</div>
  </div>
</div>
}
<!-- <div class="loading">
    @if (this.loadingService.isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
</div> -->
<router-outlet />